import { ORIGIN_META } from "@/lib/provenance";

// Small per-record origin pill. <OriginBadge origin={row.data_origin} />
export function OriginBadge({ origin, size = "sm", showIcon = true, className = "" }) {
  const meta = ORIGIN_META[origin] || ORIGIN_META.unverified;
  const { Icon } = meta;
  const px = size === "xs" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-[11px]";
  const iconSize = size === "xs" ? "w-2.5 h-2.5" : "w-3 h-3";
  return (
    <span
      data-testid={`origin-badge-${origin || "unverified"}`}
      title={meta.full}
      className={`inline-flex items-center gap-1 rounded-full border font-medium ${meta.tone} ${px} ${className}`}
    >
      {showIcon && <Icon className={iconSize} />}
      <span className="whitespace-nowrap">{meta.label}</span>
    </span>
  );
}
